<div class="flex gap-1">
  <ui-badge>
    <span class="max-w-[100px] overflow-hidden text-ellipsis whitespace-nowrap tabular-nums">
      {{
        energyInterfaces()[0]?.maloID ||
          energyInterfaces()[0]?.label ||
          ('cockpit.supplierContracts.card.unknownMaloId' | transloco)
      }}
    </span>
  </ui-badge>
  @if (energyInterfaces().length > 1) {
    <ui-badge>
      <span class="tabular-nums"> +{{ energyInterfaces().length - 1 }} </span>
    </ui-badge>
  }
</div>
